import React from "react"
import { Col, Container, Nav, Row, Tab } from "react-bootstrap"
import { CustomerCoachingBookingList, CustomerCourtBookingList } from "../../sub-modules"


const CustomerBookingHistory = () => {

  return (
    <Container fluid className="g-0">
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <Row>
          <Col sm={12}>
            <Nav variant="pills" className="mb-3">
              <Nav.Item>
                <Nav.Link eventKey="first">Court</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second">Coaching</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={12}>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <CustomerCourtBookingList situationType="past" />
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                <CustomerCoachingBookingList situationType="past" />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Container>
  )
}

export { CustomerBookingHistory }